import React from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";

// This is just a temporary function for wrapping components which need access to the router props
// Used as backwards compatibility for the old react router dom
export const withRouter = (Component: React.ComponentType) => (props: any) => {
  const navigate = useNavigate();
  const params = useParams();
  const location = useLocation();

  return (
    <Component
      {...props}
      navigate={navigate}
      match={{ params }}
      location={location}
    />
  );
};
